// ConfirmationDialog.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Divider,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Heading from "../common/Heading/Heading"
import { useTheme } from '@mui/material/styles';
import withTimedDisplay from '../../utils/timedAlert';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  error,
  showAlert,
  setShowAlert,
}) => {
  const theme = useTheme();
  const TimedAlert = withTimedDisplay(Alert);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <div className="flex justify-between items-center">
          <Heading title={title} />
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <Divider sx={{ mt: 1 }} />
      </DialogTitle>
      <DialogContent>
        {error && showAlert && (
          <div className="mb-2">
            <TimedAlert setShowAlert={setShowAlert} severity="error">
              {error}
            </TimedAlert>
          </div>
        )}
        <DialogContentText sx={{ fontSize: "14px" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="px-4 mb-4 ">
          <Button
            onClick={onConfirm}
            type="submit"
            sx={{
              py: 1,
              background: theme.palette.primary[500],
              color: "white",
            }}
            variant="contained"
          >
            {confirmButtonText}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;